import { DataBean } from "../DataBean";

export class QualityMeasurementInspections extends DataBean {

  public async getQualityMeasurementInspectionsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityMeasurementInspectionsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityMeasurementInspectionsRender( page: number,rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityMeasurementInspectionsRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityMeasurementInspections(idqualitymeasurementinspections: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityMeasurementInspections_Number", [idqualitymeasurementinspections]);
  }

  public async updateQualityMeasurementInspections(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityMeasurementInspections_updateQualityMeasurementInspections_com.orange.finance.processcontract.bean.QualityMeasurementInspections",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityMeasurementInspections",
        },
      ]
    );
  }
}
